module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', [_c('div', {
    staticClass: "layoutTop"
  }), _vm._v(" "), _c('b-container', {
    staticClass: "main-content homepageBackgroundImage icon-homepage-button-request-document",
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', {
    staticClass: "colorOverlay"
  }), _vm._v(" "), _c('b-row', {
    staticClass: "homepageTextBloc1"
  }, [_c('b-col', {
    attrs: {
      "sm": "12"
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade-title",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "homepageTitle homepageTitleText"
  }, [_vm._v("\n            MONEYROAD KYC\n          ")])])], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "homepageTextBloc2"
  }, [_c('b-col', {
    attrs: {
      "sm": "12"
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade-title",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "homepageBaseline homepageBaselineText d-flex"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('Homepage.baselineKYC')) + "\n            "), _c('br'), _vm._v("\n            " + _vm._s(_vm.$t('Homepage.all2')) + "\n          ")])])], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "homepageTextBloc3"
  }, [_c('b-col', {
    attrs: {
      "sm": "12"
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade-title",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "homepageSubTitle homepageSubTitleText"
  }, [_c('img', {
    staticClass: "homepageSubTitleLogo",
    attrs: {
      "src": require("./../../assets/static/images/StreamMind_horizontal.png")
    }
  })])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-97994700", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97994700","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/HomepageKYC.vue
// module id = 2489
// module chunks = 2